import React from 'react';
import pt from 'prop-types';

import { formatNumber } from 'utils';

function formatCount(collection, locale) {
  const countText = formatNumber(collection.count, locale);

  if (!collection.limit_count) {
    return countText;
  }

  if (collection.count !== collection.limit_count) {
    return countText;
  }

  return `more than ${countText} records`;
}

export default class CollectionShowing extends React.PureComponent {
  static propTypes = {
    collection: pt.object.isRequired,
  };

  static contextTypes = {
    client: pt.object.isRequired,
  };

  render() {
    // The partners root provides no `client`
    const locale = this.context.client?.locale;

    const { collection } = this.props;

    return (
      <div className="collection-showing">
        Showing
        {collection.pages && collection.pages[collection.page] ? (
          <span>
            &nbsp;
            {formatNumber(
              collection.pages[collection.page].start,
              locale,
            )} - {formatNumber(collection.pages[collection.page].end, locale)}{' '}
            of {formatCount(collection, locale)}
          </span>
        ) : (
          <span>
            &nbsp;1 - {formatNumber(collection.count, locale)} of{' '}
            {formatCount(collection, locale)}
          </span>
        )}
      </div>
    );
  }
}
